export default "__VITE_ASSET__WWzH2jxL__"